import { Checkbox, FormControlLabel, Typography, Box } from '@mui/material';
import Colors from '../../../assets/Variables/ColorsVariables';

const CheckBoxToggle = ({
    checked,
    onChange,
    title = "Exact Match",
    label = "Exact",
    size = "small",
    disabled = false
}) => {
    const handleChange = (event) => {
        onChange(event.target.checked);
    };

    return (
        <Box>
            <Typography
                sx={{
                    fontFamily: "Plus Jakarta Sans, sans-serif",
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: 1.4,
                    color: Colors.Secondary_700,
                    marginTop: "-25px",
                    marginBottom: "5px",
                }}
            >
                {title}
            </Typography>

            <FormControlLabel
                control={
                    <Checkbox
                        checked={checked}
                        onChange={handleChange}
                        size={size}
                        disabled={disabled}
                    />
                }
                label={label}
                sx={{
                    m: 0,
                    alignSelf: 'center',
                    '& .MuiFormControlLabel-label': {
                        fontFamily: "Plus Jakarta Sans, sans-serif",
                        fontWeight: 400,
                        fontSize: "12px",
                        lineHeight: 1.4,
                        color: Colors.Secondary_700,
                    },
                    '& .MuiCheckbox-root': {
                        padding: '4px',
                        color: Colors.Secondary_700,
                        '&.Mui-checked': {
                            color: Colors.Primary_500,
                        }
                    }
                }}
            />
        </Box>
    );
};

export default CheckBoxToggle;